// React
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Containers Injections
import { AccountsInjection } from './../../containers/accountsInjection';

// View
import { AccountListPage } from './view';

export const AccountsList = () => {
  const { success, accounts, getAccounts, deleteAccounts } =
    AccountsInjection();

  const history = useHistory();
  const { push } = useHistory();

  const handleDeleteAccount = (id) => {
    deleteAccounts(id);
  };

  const handleEditAccount = (item) => {
    history.push(`/financeiro/contas/edit/${item.id}`);
  };

  const handleButton = (route) => {
    history.push(route);
  };

  useEffect(() => {
    getAccounts();
  }, [success]);

  return (
    <AccountListPage
      accounts={accounts}
      handleButton={handleButton}
      handleEditAccount={handleEditAccount}
      handleDeleteAccount={handleDeleteAccount}
      handleNewAccount={() => push('/contas/novo')}
    />
  );
};
